import axios from 'axios'

export async function getSwapArchive(search) {
    console.log('object')
    return axios
        .get(`${process.env.API_URL}/swap-replacements/archive-search`, {
            params: {
                search
            }
        })
        .then(response => response.data)
}
